import work from './components/work.vue';
import identity from './components/identity.vue';
import about from './components/about.vue';

export const routes = [
    { path: '/', name: 'home', component: work },
    { path: '/work', component: work },
    { path: '/identity', component: identity },
    { path: '/about', component: about },
    { path: '/redirect-me', redirect: { name: 'home' } },
    { path: '/:pathMatch(.*)*', redirect: '/' }
];